import { Button } from '@mantine/core'
import { useState } from 'react'

import { useQueryGetStoreDetails } from '@flecto/core/saas'
import { useTranslation } from '@flecto/translations'
import { Page } from '@flecto/ui/saas'

import { FormStoreSettings } from '../../components/FormStoreSettings/FormStoreSettings'

export function PageStoreSettings() {
  const { t } = useTranslation('saas', { keyPrefix: 'profile_store' })

  const [isUpdating, setIsUpdating] = useState(false)

  const { data: store, isLoading } = useQueryGetStoreDetails()

  return (
    <Page withContainer withLoading={isLoading}>
      <Page.Title>{t('page.title')}</Page.Title>
      <Page.Actions>
        <Button type='submit' form='form-store-settings' loading={isUpdating}>
          {t('page.submit')}
        </Button>
      </Page.Actions>
      <Page.Content>
        <FormStoreSettings
          id='form-store-settings'
          store={store}
          onChangeLoading={setIsUpdating}
        />
      </Page.Content>
    </Page>
  )
}
